import types from "./types"

export const getTrainers = (payload) => ({type: types.GET_TRAINERS, payload})
export const getTrainersResponse = (payload) => ({type: types.GET_TRAINERS_RESP, payload})
export const getTrainersClear = () => ({type: types.GET_TRAINERS_CLEAR})

export const getInternalTrainers = (payload) => ({type: types.GET_INTERNAL_TRAINERS, payload})
export const getInternalTrainersResponse = (payload) => ({type: types.GET_INTERNAL_TRAINERS_RESP, payload})
export const getInternalTrainersClear = () => ({type: types.GET_INTERNAL_TRAINERS_CLEAR})

export const getExternalTrainers = (payload) => ({type: types.GET_EXTERNAL_TRAINERS, payload})
export const getExternalTrainersResponse = (payload) => ({type: types.GET_EXTERNAL_TRAINERS_RESP, payload})
export const getExternalTrainersClear = () => ({type: types.GET_EXTERNAL_TRAINERS_CLEAR})

export const getMembers = (payload) => ({type: types.GET_MEMBERS, payload})
export const getMembersResponse = (payload) => ({type: types.GET_MEMBERS_RESP, payload})
export const getMembersClear = () => ({type: types.GET_MEMBERS_CLEAR})

export const postWorkshop = (payload) => ({type: types.POST_WORKSHOP_SUBMIT, payload})
export const postWorkshopResponse = (payload) => ({type: types.POST_WORKSHOP_RESPONSE, payload})
export const postWorkshopClear = () => ({type: types.POST_WORKSHOP_CLEAR})

export const getWorkshop = (payload) => ({type: types.GET_WORKSHOP_DATA, payload})
export const getWorkshopResponse = (payload) => ({type: types.GET_WORKSHOP_DATA_RESPONSE, payload})
export const getWorkshopClear = () => ({type: types.GET_WORKSHOP_DATA_CLEAR})

export const updateWorkshopData = (payload) => ({type: types.UPDATE_WORKSHOP_DATA, payload})
export const updateWorkshopDataResponse = (payload) => ({type: types.UPDATE_WORKSHOP_DATA_RESPONSE, payload})
export const updateWorkshopDataClear = () => ({type: types.UPDATE_WORKSHOP_DATA_CLEAR})

export const postWorkshopTimezone = (payload) => ({type: types.POST_WORKSHOP_TIMEZONE, payload})
export const postWorkshopTimezoneResponse = (payload) => ({type: types.POST_WORKSHOP_TIMEZONE_RESPONSE, payload})
export const postWorkshopTimezoneClear = () => ({type: types.POST_WORKSHOP_TIMEZONE_CLEAR})


export const updateWorkshop = (payload) => ({type: types.UPDATE_WORKSHOP, payload})
export const updateWorkshopResponse = (payload) => ({type: types.UPDATE_WORKSHOP_RESPONSE, payload})
export const updateWorkshopResponseClear = () => ({type: types.UPDATE_WORKSHOP_RESPONSE_CLEAR})